// extracted by mini-css-extract-plugin
export default {"cta":"CF-z","disabled":"DF-z"};